import { createContext } from 'react';

/**
 * Whether the surrounding card runs the shared label/value grid (`EconomyCard rowStack`).
 *
 * A `SettingsRow` only goes `display: contents` when it has that grid to join; outside one
 * it lays out its own columns instead of collapsing into the nearest parent. Its own file
 * so the card and the row can both reach it without importing each other.
 */
export const RowStackContext = createContext(false);

export default RowStackContext;
